import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "products__single-product q-p-1 q-position-relative q-d-flex" }
const _hoisted_3 = { class: "products__single-product-image-container q-col-4 q-col-md-5 q-p-0" }
const _hoisted_4 = ["src", "alt", "width", "height"]
const _hoisted_5 = { class: "products__single-product-info q-col-8 q-col-md-7 q-px-2 q-text-black q-text-start" }
const _hoisted_6 = { class: "products__single-product-title q-p-0 q-m-0 q-fw-semibold" }
const _hoisted_7 = ["href"]

import { computed, inject, ref, toRefs } from 'vue';
import { generateStaticImage, addDisplayMacros, formatPrice, parsePrice, getDiscount, getRealPrice } from '@/core/utils';
import { createTemplate } from '@/core/Template';
import { SmartSearchConfigInterface } from '@/core/types';
import AutocompletePriceBox from '@/components/AutocompletePopup/AutocompletePriceBox.vue';

// Rozszerzamy props o customTemplate, który będzie zawierał HTML szablonu z endpointu

export default /*@__PURE__*/_defineComponent({
  __name: 'SingleProduct',
  props: ['result', 'customTemplate'],
  setup(__props) {

const props = __props;
const { link, link_click, variants, id } = toRefs(props.result);
const firstVariant = ref(variants.value[0]);

// Pobranie konfiguracji
const SmartSearchConfig = ref(inject<SmartSearchConfigInterface>('SmartSearchConfig')!);
const { width, height } = SmartSearchConfig.value.onfocus.productImageSize;
const { useQuarticImages } = SmartSearchConfig.value.serp.productImageSize;
const { currency: currencyCode, removeDecimals } = SmartSearchConfig.value.appConfiguration;

// Obliczanie ścieżki do obrazu
const staticImage = computed(() => {
  const imageLink = firstVariant.value.image_link;
  if (!useQuarticImages) {
    return imageLink;
  }
  return imageLink
      ? generateStaticImage(imageLink, width, height)
      : generateStaticImage('https://static.quartic.com.pl/img/no-image/no-image.png', width, height);
});

// Obsługa linku
const actualLink = ref(link.value);
const handleClick = () => {
  actualLink.value = link_click.value.replace(/^http:/, 'https:');
};

// Dodatkowe funkcje i obliczenia dla makr
const secondPrice = firstVariant.value.old_price || firstVariant.value.sale_price;
const { price, oldPrice } = getRealPrice(parsePrice(firstVariant.value.price), parsePrice(secondPrice));
const omnibusPrice = parsePrice(firstVariant.value.omnibus_price);
const formattedPrice = formatPrice(price, currencyCode, removeDecimals);
const formattedPriceOld = formatPrice(oldPrice, currencyCode, removeDecimals);
const formattedOmnibusPrice = formatPrice(omnibusPrice, currencyCode, removeDecimals);
const discount = getDiscount(price, oldPrice);

// Funkcja przygotowująca czysty link z modyfikacją protokołu
const prepareClearLink = (link: string, clickLink: string) => {
  return ` href="${link}" data-href="${clickLink.replace(/^http:/, 'https:')}" onmousedown="return this.href = this.getAttribute('data-href');" ontouchstart="return this.href = this.getAttribute('data-href');" `;
};

// Mechanizm generowania HTML przy użyciu customTemplate
const generatedHtml = ref('');
if (props.customTemplate) {
  // Rozszerzamy dane produktu o dodatkowe właściwości (makra)
  firstVariant.value.discount = discount;
  firstVariant.value.image_link_cdn = staticImage.value;
  firstVariant.value.price_formatted = formattedPrice;
  firstVariant.value.price_number = price;
  firstVariant.value.old_price_formatted = formattedPriceOld;
  firstVariant.value.old_price_number = oldPrice;
  firstVariant.value.omnibus_price_formatted = formattedOmnibusPrice;
  firstVariant.value.omnibus_price_number = omnibusPrice;
  firstVariant.value.id = id.value;
  firstVariant.value.link_click = link_click.value;
  firstVariant.value.clear_link = prepareClearLink(link.value, link_click.value);

  // Możemy dodatkowo modyfikować obiekt za pomocą funkcji addDisplayMacros
  addDisplayMacros(firstVariant.value);

  // Generujemy HTML na podstawie niestandardowego szablonu oraz danych produktu
  generatedHtml.value = createTemplate(props.customTemplate, firstVariant.value, variants.value);
}

return (_ctx: any,_cache: any) => {
  return (__props.customTemplate)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        innerHTML: generatedHtml.value,
        class: "products__single-product-container q-col-sm-12 q-col-md-6"
      }, null, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("div", {
        key: __props.result.id,
        class: "products__single-product-container q-col-sm-12 q-col-md-6"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "products__single-product-image q-p-1 q-img-fluid",
              src: staticImage.value,
              alt: __props.result.title,
              width: _unref(width),
              height: _unref(height)
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.result.title), 1),
            _createVNode(AutocompletePriceBox, { product: firstVariant.value }, null, 8, ["product"]),
            _createElementVNode("a", {
              href: actualLink.value,
              onClick: handleClick,
              class: "q-stretched-link"
            }, null, 8, _hoisted_7)
          ])
        ])
      ]))
}
}

})